module.exports = __webpack_public_path__ + "img/keenBackBox@2x.1ef58ccf.png";